import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./styles/TopBar.scss";

function NavLinks(props) {
  // Variants for the menu container
  const containerVariants = {
    hidden: { opacity: 0, y: -50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        when: "beforeChildren",
        staggerChildren: 0.1,
      },
    },
    exit: {
      opacity: 0,
      y: -50,
      transition: { duration: 1 },
    },
  };

  // Variants for each list item
  const itemVariants = {
    hidden: { opacity: 0, y: -40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.3 },
    },
  };

  return (
    <AnimatePresence>
      <motion.div
        className="link-wrapper"
        initial="hidden"
        animate="visible"
        exit="exit"
        variants={containerVariants}
        onClick={() => props.isMobile && props.closeMobileMenu()}
      >
        <ul className="links">
          <motion.li
            variants={itemVariants}
            onClick={() => props.isMobile && props.closeMobileMenu()}
          >
            <a href="#home-page" className="link">
              Home
            </a>
          </motion.li>
          <motion.li
            variants={itemVariants}
            onClick={() => props.isMobile && props.closeMobileMenu()}
          >
            <a href="#about-me" className="link">
              About Me
            </a>
          </motion.li>
          <motion.li
            variants={itemVariants}
            onClick={() => props.isMobile && props.closeMobileMenu()}
          >
            <a href="#projects" className="link">
              Projects
            </a>
          </motion.li>
          <motion.li
            variants={itemVariants}
            onClick={() => props.isMobile && props.closeMobileMenu()}
          >
            <a href="#testimonials" className="link">
              Testimonials
            </a>
          </motion.li>
          <motion.li
            variants={itemVariants}
            onClick={() => props.isMobile && props.closeMobileMenu()}
          >
            {/* New link can be added after deciding on which CV to use */}
            <a
              href="https://drive.google.com/file/d/1k33BNtnAEqGNILT8J57aAZQXJrdbtfBG/view?usp=sharing"
              target="_blank"
              rel="noreferrer"
              className="link"
            >
              CV
            </a>
          </motion.li>
          <motion.li
            variants={itemVariants}
            onClick={() => props.isMobile && props.closeMobileMenu()}
          >
            <a href="#contact-me" className="link">
              Contact Me
            </a>
          </motion.li>
        </ul>
      </motion.div>
    </AnimatePresence>
  );
}

export default NavLinks;
